<section id="footer">
  <footer class="site-footer">
    <div class="container">
      <div class="row">
        <div class="col-lg-4">
          <div class="mb-5">
            <h3 class="footer-heading mb-4">About Stride Real Estate</h3>
            <p>
              Find your next home with Stride Real Estate. We commit to
              providing you with a smooth, worry-free home buying experience.
            </p>
          </div>
        </div>
        <div class="col-lg-4 mb-5 mb-lg-0">
          <div class="row mb-5">
            <div class="col-md-12">
              <h3 class="footer-heading mb-4">Navigations</h3>
            </div>
            <div class="col-md-6 col-lg-6">
              <ul class="list-unstyled">
                <li><a routerLink="">Home</a></li>
                <li><a routerLink="/our-team">Our Team</a></li>
                <li><a href="https://stridecareer.com">Join</a></li>
              </ul>
            </div>
            <div class="col-md-6 col-lg-6">
              <ul class="list-unstyled">
                <li><a routerLink="/company">Company</a></li>
                <li><a routerLink="/contact">Contact Us</a></li>
                <li><a routerLink="/privacy">Privacy Policy</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-lg-4 mb-5 mb-lg-0">
          <h3 class="footer-heading mb-4">Follow Us</h3>
          <div>
            <a
              href="https://www.facebook.com/striderealestate/"
              class="pl-0 pr-3"
              ><i class="fab fa-facebook"></i>
            </a>
            <a
              href="https://www.instagram.com/striderealestate/?hl=en"
              class="pl-3 pr-3"
              ><i class="fab fa-instagram icon-item-right"></i
                ></a>
            <a
              href="https://www.linkedin.com/company/stride-real-estate/?originalSubdomain=in"
              class="pl-3 pr-3"
              ><i class="fab fa-linkedin icon-item-right"></i
                ></a>
            <a href="https://twitter.com/RealStride" class="pl-3 pr-3"
              ><i class="fab fa-twitter icon-item-right"></i
                ></a>
                <a href="https://www.pinterest.com/striderealestate/boards/" class="pl-3 pr-3"
              ><i class="fab fa-pinterest icon-item-right"></i
                ></a>
          </div>
        </div>
      </div>
      <div class="row pt-5 mt-5 text-center">
        <div class="col-md-6">
          <a
            href="../../assets/documents/Information about Brokerage Services SellerLandlord__112015_ts74004.pdf"
            >Information About Brokerage Services</a
          >
        </div>

        <div class="col-md-6">
          <a href="../../assets/documents/TREC.pdf"
            >Texas Real Estate and Consumer Protection Notice</a
          >
        </div>
      </div>
      <div class="row pt-5 mt-5 text-center">
        <div class="col-md-12">
          <p>
            Copyright &copy;
            <script>
              document.write(new Date().getFullYear());
            </script>
            All rights reserved by Stride Real Estate
            
          </p>
        </div>
      </div>
    </div>
  </footer>
</section>
